import { render, staticRenderFns } from "./ForgotPasswordFloripa.vue?vue&type=template&id=138c84f6&scoped=true"
import script from "./ForgotPasswordFloripa.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordFloripa.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordFloripa.vue?vue&type=style&index=0&id=138c84f6&prod&scoped=true&lang=css"
import style1 from "./ForgotPasswordFloripa.vue?vue&type=style&index=1&id=138c84f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c84f6",
  null
  
)

export default component.exports